import classNames from "classnames";
import { ButtonHTMLAttributes, FC, memo } from "react";

type Props = {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "link" | "white";
  form?: "base" | "circle";
} & ButtonHTMLAttributes<HTMLButtonElement>;

const Button: FC<Props> = ({ children, variant = "primary", form = "base", className, ...props }) => {
  return (
    <button {...props} className={classNames("button", `button--${variant}`, `button--${form}`, className)}>
      {children}
    </button>
  );
};

export default memo(Button);
